import styled from "@emotion/styled";
import background from "../image/red_black_bg.png";

export const Bg = styled.div`
  background-image: url(${background});
  background-size: cover;
  background-position: bottom;
  font-family: "Noto Sans JP", sans-serif;
`;
